import { IFavoriteToggleResponse, IFavoritesResponse } from '../interfaces/heavyDutyMachinery/IFavorites';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

export const addFavorite = async (spaceId: string): Promise<IFavoriteToggleResponse> => {
  const response = await apiService<IFavoriteToggleResponse>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_FAVORITE_TOGGLE(spaceId),
    method: HTTP_METHODS.POST,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to save favorite');
};

export const removeFavorite = async (spaceId: string): Promise<IFavoriteToggleResponse> => {
  const response = await apiService<IFavoriteToggleResponse>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_FAVORITE_TOGGLE(spaceId),
    method: HTTP_METHODS.DELETE,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to remove favorite');
};

// Most-recently-saved first, cursor-paginated -- same convention as
// searchHeavyDutyMachineries' own nextCursor.
export const getMyFavorites = async (cursor?: string, pageSize = 20): Promise<IFavoritesResponse> => {
  const params: Record<string, string> = { pageSize: String(pageSize) };
  if (cursor) params.cursor = cursor;

  const response = await apiService<IFavoritesResponse>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_FAVORITES_MINE,
    method: HTTP_METHODS.GET,
    params,
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load favorites');
};
